import React from 'react';
import CustomListContainer from "../../../../../components/CustomListContainer";
import CustomListItem from "../../../../../components/CustomListItem";
import {ListItemText} from "@mui/material";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import DownloadIcon from "@mui/icons-material/Download";
import CustomPhotoPicker from "../../../../../components/PhotoPicker/CustomPhotoPicker";
import {ACTION_MODEL} from "../../../../../Helpers/ActionModel";
import {FILE_TYPE} from "../../../../../Helpers/fileType";
import routes from "../../../../../Routes/routes";
import {downloadPrivacyDocs} from "../../../Visitor/External/Model/Model";
import {useTranslation} from "react-i18next";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const WhiteListAutomatic = (
    {
        photoPickerFile,
        setPhotoPickerFile
    }
) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={"row mt-5"}>
                <div className={"col-12"}>
                    <p className={"fs-14px ibl-font-w-600"}>
                        {t('to_upload_the_whitelist_of_users_authorized_to_register_for_your_event_please_follow_the_steps_below')}
                    </p>
                </div>

                <div className={"col-12 pl-5"}>
                    <CustomListContainer styleType={"disc"}>
                        <CustomListItem key={1} display={'list-item'}>
                            <div className={"d-inline-flex"}>
                                <ListItemText primary={t('click_to_download_the_template')} />
                                <ButtonIcon
                                    id='btn_wla_download'
                                    Icon={DownloadIcon}
                                    onClick={() => {
                                        downloadPrivacyDocs(routes.docs.reservationTemplate, t("template"))
                                    }}
                                    title={''}
                                    className='btn-background-transparent ml-2'
                                    iconProps={'btn-icon-svg-black btn-icon-svg-12px'}
                                />
                            </div>
                        </CustomListItem>
                        <CustomListItem key={2} display={'list-item'} text={t('fill_on_it_the_data_and_make_sure_you_are_following_the_correct_way_to_fill_it')}/>
                        <CustomListItem key={3} display={'list-item'} text={t('drag_&_drop_the_file_or_click_on_the_shape_to_search_on_the_explorer')}/>
                    </CustomListContainer>
                </div>
                <div className={"col-12"}>
                    <CustomPhotoPicker
                        id='fp_wla_upload_white_list'
                        photoPicker={photoPickerFile}
                        setPhotoPicker={setPhotoPickerFile}
                        actionModel={ACTION_MODEL.CREATE}
                        accept={{ ...FILE_TYPE.XLSX }}
                        required={false}
                        classWith={'w-100'}
                        showPreview={false}
                    />
                </div>
            </div>
        </>
    )
}


export default WhiteListAutomatic
